import type {ReactElement} from 'react';
import React from 'react';
import type {RGBA} from '@Utils/color.util';
import {colorToRgbaArray, rgbaToHexString} from '@Utils/color.util';
import {BaseCustomShadowColorPanel} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-custom-shadow-color-panel';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetKeyFromShadowOfActiveItem} from '@Hooks/poster-editor/useGetKeyFromShadowOfActiveItem';

export function CustomShadowColorPanel(): ReactElement<any> {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const activeItemDropshadowColor = useGetKeyFromShadowOfActiveItem('color');

  if (!activeItem || !activeItemDropshadowColor) {
    throw new Error(`No active item`);
  }

  const updateCustomShadow = (dropShadowColor: RGBA, undoable = true): void => {
    void activeItem.updateFromObject(
      {
        shadow: {
          color: rgbaToHexString(dropShadowColor),
        },
      },
      {
        undoable,
      }
    );
  };

  return <BaseCustomShadowColorPanel dropShadowColor={colorToRgbaArray(activeItemDropshadowColor)} onUpdateColor={updateCustomShadow} />;
}
